import { render, staticRenderFns } from "./Liket.vue?vue&type=template&id=33d68381"
import script from "./Liket.vue?vue&type=script&lang=js"
export * from "./Liket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports